import { combineReducers, configureStore } from "@reduxjs/toolkit";
import statisticsReducer from "./statisticsSlice";
import { settingsSlice } from "./settingsSlice";
import { notesSlice } from "@src/store/notesSlice";
import { eventsSlice } from "@src/store/eventsSlice";
import { reportsSlice } from "@src/store/reportsSlice";
import { exclusionRulesSlice } from "@src/store/exclusionRulesSlice";
import { poMappingSlice } from "@src/store/poMappingSlice";
import { pullEventsSlice } from "@src/store/pullEventsSlice";
import venueAliasesReducer from "@src/store/venueAliasesSlice";
import cityAliasesReducer from "@src/store/cityAliasesSlice";
import aiConfidenceReducer from "@src/store/aiConfidenceSlice";

const rootReducer = combineReducers({
	settings: settingsSlice.reducer,
	statistics: statisticsReducer,
	notes: notesSlice.reducer,
	events: eventsSlice.reducer,
	reports: reportsSlice.reducer,
	exclusionRules: exclusionRulesSlice.reducer,
	poMapping: poMappingSlice.reducer,
	pullEvents: pullEventsSlice.reducer,
	venueAliases: venueAliasesReducer,
	cityAliases: cityAliasesReducer,
	aiConfidence: aiConfidenceReducer,
});

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
